export const availableCountries = ["CA", "US", "AU"];

export const currencies = [
    { value: "CAD", text: "Canadian Dollar" },
    { value: "USD", text: "US Dollar" },
    { value: "AUD", text: "Australian Dollar" },
    // {"value": "EUR","text": "Euro"},
];

export const countries = [
    { value: "CA", text: "Canada" },
    { value: "US", text: "United States" },
    { value: "AU", text: "Australia" },
];

export const countryCurrency = [
    { value: "CAD", text: "Canada" },
    { value: "USD", text: "United States" },
    { value: "AUD", text: "Australia" },
];

export const regionToCurrencyMap = {
    US: "USD",
    CA: "CAD",
    AU: "AUD",
};

export const currencyToRegionMap = {
    USD: "US",
    CAD: "CA",
    AUD: "AU",
};
